<footer id="footer" class="footer color-bg">
  <div class="footer-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-3">
          <div class="module-heading">
            <h4 class="module-title">Contact Us</h4>
            <!-- <div *ngIf="chatcode!=null && chatcode!=undefined  && chatcode!='undefined'" [innerHTML]="chatcode | safe: 'html'"></div> -->

          </div>
          <div class="module-body">
            <ul class="toggle-footer">
              <li class="media" id="address1" *ngIf="addressshow=='1'">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-map-marker fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact==null || Secondcontact==undefined || Secondcontact.cAddress==null 
                || Secondcontact.cAddress==undefined || Secondcontact.cAddress==''">
                  <a [routerLink]="['/contact']">
                    <p *ngIf="address!=undefined && address!=null">{{address[0]}} {{address[1]}}, <br> </p>
                    <p *ngIf="address!=undefined && address!=null">{{address[2]}} {{address[3]}}, {{contactDtl.state}},
                      {{contactDtl.postal_code}}<br> </p>
                    <p>{{contactDtl.country_code}}</p>
                  </a>
                </div>
                <div class="media-body" *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cAddress!=null 
                && Secondcontact.cAddress!=undefined && Secondcontact.cAddress!=''">
                  <a [routerLink]="['/contact']">
                    <p [innerHTML]="Secondcontact.cAddress | safe: 'html'"> </p>
                  </a>
                </div>
              </li>
              <li class="media" id="footerphone">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-phone fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact==null || Secondcontact==undefined || Secondcontact.cPhone==null 
                || Secondcontact.cPhone==undefined || Secondcontact.cPhone==''">
                  <a *ngIf="contactDtl!=undefined && contactDtl!=null && contactDtl.phone!=undefined && contactDtl.phone!=null"
                    href="tel:{{contactDtl.phone}}">
                    <p>{{contactDtl.phone | phone:'US' }}
                    </p>
                  </a>
                </div>
                <div class="media-body" *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cPhone!=null 
                && Secondcontact.cPhone!=undefined && Secondcontact.cPhone!=''">
                  <a href="tel:{{Secondcontact.cPhone}}">
                    <p>{{Secondcontact.cPhone | phone:'US' }}
                    </p>
                  </a>
                </div>
              </li>
              <li class="media" id="footeremail">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact==null || Secondcontact==undefined || Secondcontact.cEmail==null 
                || Secondcontact.cEmail==undefined || Secondcontact.cEmail==''">
                  <span *ngIf="contactDtl!=undefined && contactDtl!=null">
                    <a href="mailto:{{contactDtl.co_email}}"> {{contactDtl.co_email}}</a>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cEmail!=null 
                && Secondcontact.cEmail!=undefined && Secondcontact.cEmail!=''">
                  <span>
                    <a href="mailto:{{Secondcontact.cEmail}}"> {{Secondcontact.cEmail}}</a>
                  </span>
                </div>
              </li>
              <li class="media" id="co_web">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-globe fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact==null || Secondcontact==undefined || Secondcontact.cWebsite==null 
                || Secondcontact.cWebsite==undefined || Secondcontact.cWebsite==''">
                  <span *ngIf="contactDtl!=undefined && contactDtl!=null">
                    <a target="_blank" href="http://{{contactDtl.co_web}}"> {{contactDtl.co_web}}</a>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cWebsite!=null 
                && Secondcontact.cWebsite!=undefined && Secondcontact.cWebsite!=''">
                  <span>
                    <a target="_blank" href="http://{{Secondcontact.cWebsite}}"> {{Secondcontact.cWebsite}}</a>
                  </span>
                </div>
              </li>
              <li class="media" id="co_fax">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-fax fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact==null || Secondcontact==undefined || Secondcontact.cFax==null 
                || Secondcontact.cFax==undefined || Secondcontact.cFax==''">
                  <span *ngIf="contactDtl!=undefined && contactDtl!=null">
                    <a href="tel:{{contactDtl.fax}}"> {{contactDtl.fax | phone:'US'}}</a>
                  </span>
                </div>
                <div class="media-body" *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cFax!=null 
                && Secondcontact.cFax!=undefined && Secondcontact.cFax!=''">
                  <span>
                    <a href="tel:{{Secondcontact.cFax}}"> {{Secondcontact.cFax | phone:'US'}}</a>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined">
          <div class="module-heading">
            <h4 class="module-title">Contact Us</h4>
            <!-- <div *ngIf="chatcode!=null && chatcode!=undefined  && chatcode!='undefined'" [innerHTML]="chatcode | safe: 'html'"></div> -->

          </div>
          <div class="module-body">
            <ul class="toggle-footer">
              <li class="media" *ngIf="addressshow=='1'">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-map-marker fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined">
                  <a [routerLink]="['/contact']">
                    <p>{{secondaddressobjet.address[0]}} {{secondaddressobjet.address[1]}}, <br> </p>
                    <p>{{secondaddressobjet.address[2]}} {{secondaddressobjet.address[3]}},
                      {{secondaddressobjet.state}}, {{secondaddressobjet.postal_code}}<br> </p>
                    <p>{{secondaddressobjet.country_code}}</p>
                  </a>
                </div>

              </li>
              <li class="media" id="footer1phone">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-phone fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined && secondaddressobjet.phone!=null 
                && secondaddressobjet.phone!=undefined && secondaddressobjet.phone!=''">
                  <a *ngIf="secondaddressobjet.phone!=undefined && secondaddressobjet.phone!=null && secondaddressobjet.phone!=''"
                    href="tel:{{secondaddressobjet.phone}}">
                    <p>{{secondaddressobjet.phone | phone:'US' }}
                    </p>
                  </a>
                </div>
                <div class="media-body" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined && secondaddressobjet.phone1!=null 
                && secondaddressobjet.phone1!=undefined && secondaddressobjet.phone1!=''">
                  <a href="tel:{{secondaddressobjet.phone1}}">
                    <p>{{secondaddressobjet.phone1 | phone:'US' }}
                    </p>
                  </a>
                </div>
              </li>
              <li class="media" id="footer1email">
                <div class="pull-left">
                  <span class="icon fa-stack fa-lg">
                    <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="media-body" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined && secondaddressobjet.email!=null 
                && secondaddressobjet.email!=undefined && secondaddressobjet.email!=''">
                  <span *ngIf="secondaddressobjet!=undefined && secondaddressobjet!=null">
                    <a href="mailto:{{secondaddressobjet.email}}"> {{secondaddressobjet.email}}</a>
                  </span>
                </div>
                <div class="media-body" *ngIf="secondaddressobjet!=null && secondaddressobjet!=undefined && secondaddressobjet.email1!=null 
                && secondaddressobjet.email1!=undefined && secondaddressobjet.email1!=''">
                  <span>
                    <a href="mailto:{{secondaddressobjet.email1}}"> {{secondaddressobjet.email1}}</a>
                  </span>
                </div>
              </li>

            </ul>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3" *ngIf="webtype != '1'">
          <div class="module-heading">
            <h4 class="module-title">Customer Service</h4>
          </div>
          <div class="module-body">
            <ul class='list-unstyled'>
              <li *ngFor="let hlink of headerlinks">
                <a [routerLink]="[hlink.linkurl]"
                  *ngIf="hlink.popover && hlink.linkurl.indexOf('http')==-1" target="_blank">{{hlink.linkname}} </a>
                <a href="{{hlink.linkurl}}" *ngIf="hlink.popover && hlink.linkurl.indexOf('http')>-1"
                  target="_blank">{{hlink.linkname}} </a>
                <a [routerLink]="[hlink.linkurl]"
                  *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')==-1">{{hlink.linkname}}</a>
                <a href="{{hlink.linkurl}}"
                  *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')>-1">{{hlink.linkname}}</a>
              </li>
            </ul>

          </div>
          <br />
          <div class="container" style="padding: 0px;margin: 0px;">
            <div class="col-xs-12 col-sm-6 no-padding social" style="padding: 0px;margin: 0px;">
              <ul class="link">
                <li class="fb pull-left" *ngIf="flink!=undefined && flink!=null && flink!=''">
                  <a target="_blank" rel="nofollow" href="{{flink}}" title="Facebook"></a>
                </li>
                <li class="tw pull-left" *ngIf="tlink!=undefined && tlink!=null && tlink!=''">
                  <a target="_blank" rel="nofollow" href="{{tlink}}" title="Twitter"></a>
                </li>
                <li class="linkedin pull-left" *ngIf="llink!=undefined && llink!=null && llink!=''">
                  <a target="_blank" rel="nofollow" href="{{llink}}" title="Linkedin"></a>
                </li>
                <li class="googleplus pull-left" *ngIf="glink!=undefined && glink!=null && glink!=''">
                  <a target="_blank" rel="nofollow" href="{{glink}}" title="Google"></a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3" *ngFor="let ban1 of homebannerList">
          <a href="{{ban1.targeturl}}" target="_blank">
            <img src="{{ban1.ImageUrl}}" alt="{{ban1.Title +''+ ban1.Description}}"
              style="height: 100%;width: 100%;padding-top:15px;padding-bottom:15px;" />
          </a>
        </div>
        <!-- <div class="col-xs-12 col-sm-6 col-md-4" *ngIf="webtype != '1'">
          <div class="module-heading">
            <h4 class="module-title">Corporation</h4>
          </div>
          <div class="module-body">
            <ul class='list-unstyled'>
                <li class="cpointer"  *ngIf="isNotLoggedIn && webtype != '1'">
                    <a (click)="register()">Register</a>
                  </li>
                  <li class="cpointer" *ngIf="isNotLoggedIn && webtype=='6' && isShowSalesLogin=='1'">
                    <a (click)="slogClick()" >Sales Login</a>
                  </li>
                  <li class="cpointer" *ngIf="isNotLoggedIn">
                    <a (click)="logClick()" >Login</a>
                  </li>
                  <li class="cpointer" *ngIf="isNotLoggedIn==false">
                      <a (click)="logout()">Logout</a>
                    </li>              
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="copyright-bar">
    <div class="container">
      <div class="col-xs-12 col-sm-6 no-padding social">
        <ul class="link">
          <li class="fb pull-left">
            <a target="_blank" rel="nofollow" href="{{flink}}" title="Facebook"></a>
          </li>
          <li class="tw pull-left">
            <a target="_blank" rel="nofollow" href="{{tlink}}" title="Twitter"></a>
          </li>
          <li class="linkedin pull-left">
            <a target="_blank" rel="nofollow" href="{{llink}}" title="Linkedin"></a>
          </li> 
<li class="googleplus pull-left">
            <a target="_blank" rel="nofollow" href="{{glink}}" title="Google"></a>
          </li> 
        </ul>
      </div>
       <div class="col-xs-12 col-sm-6 no-padding">
        <div class="clearfix payment-methods">
          <ul>
            <li>
              <img src="assets/images/payments/1.png" alt="">
            </li>
            <li>
              <img src="assets/images/payments/2.png" alt="">
            </li>
            <li>
              <img src="assets/images/payments/3.png" alt="">
            </li>
            <li>
              <img src="assets/images/payments/4.png" alt="">
            </li>
            <li>
              <img src="assets/images/payments/6.png" alt="">
            </li>
          </ul>
        </div>
      </div> 
    </div>
  </div> -->
</footer>